import aboutImage from "@/assets/about-interior.jpg?format=webp&quality=80";
import hausLogoWhite from "@/assets/haus-logo-white.png";
import { useLanguage } from "@/contexts/LanguageContext";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 lg:py-32 bg-charcoal text-cream overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Visual */}
          <div className="relative order-2 lg:order-1">
            {/* Main image */}
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
              <img 
                src={aboutImage} 
                alt="HAUS lighting in elegant interior" 
                width={800}
                height={1000}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-charcoal/40" />
              {/* Centered logo */}
              <div className="absolute inset-0 flex items-center justify-center">
                <img 
                  src={hausLogoWhite} 
                  alt="HAUS" 
                  loading="lazy"
                  decoding="async"
                  className="w-48 md:w-64 lg:w-72 h-auto opacity-90"
                />
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="order-1 lg:order-2">
            <img 
              src={hausLogoWhite} 
              alt="HAUS" 
              loading="lazy"
              decoding="async"
              className="h-10 md:h-12 w-auto mb-4 opacity-80"
            />
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-[1.1]">
              {t.about.title}
              <br />
              <span className="text-gold">{t.about.titleAccent}</span>
            </h2>
            <div className="space-y-5 text-cream/60 leading-relaxed font-body">
              <p className="text-lg">{t.about.paragraph1}</p>
              <p>{t.about.paragraph2}</p>
              <p>{t.about.paragraph3}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
